import { Instagram, Twitter, Facebook, Linkedin } from "lucide-react";
import logo from "../assets/logo.png";

export function Footer() {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12 lg:mb-16">
          {/* Brand */}
          <div>
            <img
              src={logo}
              alt="BeginPack Ltd Logo"
              className="w-38 h-38 mb-4 object-contain"
            />

            <p className="font-['Plus_Jakarta_Sans'] text-gray-300 leading-relaxed mb-6 text-sm tracking-tight antialiased">
              Empowering students to become global citizens through immersive
              educational experiences around the world.
            </p>
            <div className="flex gap-3">
              {[Instagram, Twitter, Facebook, Linkedin].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="p-3 rounded-lg bg-gray-800 text-gray-300 hover:bg-[#800020] hover:text-white transition-all duration-200 hover:scale-110"
                  aria-label={`Social media link ${i + 1}`}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Destinations */}
          <div>
            <h4 className="font-['Poppins'] text-base font-bold mb-5 tracking-tight antialiased">
              Destinations
            </h4>
            <ul className="space-y-3">
              {[
                "Australia",
                "New Zealand",
                "United Kingdom",
                "Canada",
                "Europe",
              ].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    className="font-['Plus_Jakarta_Sans'] text-sm text-gray-300 hover:text-white hover:translate-x-1 inline-block transition-all duration-200 tracking-tight antialiased p-2 -m-2"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-['Poppins'] text-base font-bold mb-5 tracking-tight antialiased">
              Services
            </h4>
            <ul className="space-y-3">
              {[
                "Study Abroad Services",
                "Migration Services",
                "Flight Ticket Booking",
              ].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    className="font-['Plus_Jakarta_Sans'] text-sm text-gray-300 hover:text-white hover:translate-x-1 inline-block transition-all duration-200 tracking-tight antialiased p-2 -m-2"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Poppins'] text-base font-bold mb-5 tracking-tight antialiased">
              Contact
            </h4>
            <ul className="space-y-2.5 font-['Plus_Jakarta_Sans'] text-sm text-gray-300 tracking-tight antialiased">
              <li className="leading-relaxed">
                2 Awofeso Street Shomolu
                <br />
               Lagos, Nigeria
              </li>
              <li className="pt-2">
                <a
                  href="https://wa.me/2348138838732"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors inline-block p-2 -m-2"
                >
                  +234 813 883 8732
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@beginpack.com"
                  className="hover:text-white transition-colors inline-block break-all p-2 -m-2"
                >
                  info@beginpack.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-['Plus_Jakarta_Sans'] text-gray-500 text-sm tracking-tight antialiased">
            © {new Date().getFullYear()} BeginPack Ltd. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-6 font-['Plus_Jakarta_Sans'] text-sm text-gray-500 tracking-tight antialiased">
            <a href="#" className="hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
